// US state name/abbreviation lookup and top cities per state
// Used by location search to handle state-name queries

const STATE_LIST = [
    ['AL', 'Alabama', ['Birmingham', 'Montgomery', 'Huntsville', 'Mobile', 'Tuscaloosa']],
    ['AK', 'Alaska', ['Anchorage', 'Fairbanks', 'Juneau', 'Sitka', 'Ketchikan']],
    ['AZ', 'Arizona', ['Phoenix', 'Tucson', 'Mesa', 'Chandler', 'Scottsdale']],
    ['AR', 'Arkansas', ['Little Rock', 'Fort Smith', 'Fayetteville', 'Springdale', 'Jonesboro']],
    ['CA', 'California', ['Los Angeles', 'San Francisco', 'San Diego', 'San Jose', 'Sacramento']],
    ['CO', 'Colorado', ['Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Boulder']],
    ['CT', 'Connecticut', ['Bridgeport', 'New Haven', 'Hartford', 'Stamford', 'Waterbury']],
    ['DE', 'Delaware', ['Wilmington', 'Dover', 'Newark', 'Middletown', 'Smyrna']],
    ['FL', 'Florida', ['Jacksonville', 'Miami', 'Tampa', 'Orlando', 'St. Petersburg']],
    ['GA', 'Georgia', ['Atlanta', 'Augusta', 'Columbus', 'Savannah', 'Athens']],
    ['HI', 'Hawaii', ['Honolulu', 'Hilo', 'Kailua', 'Kapolei', 'Kaneohe']],
    ['ID', 'Idaho', ['Boise', 'Meridian', 'Nampa', 'Idaho Falls', 'Pocatello']],
    ['IL', 'Illinois', ['Chicago', 'Aurora', 'Joliet', 'Naperville', 'Rockford']],
    ['IN', 'Indiana', ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel']],
    ['IA', 'Iowa', ['Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City', 'Iowa City']],
    ['KS', 'Kansas', ['Wichita', 'Overland Park', 'Kansas City', 'Olathe', 'Topeka']],
    ['KY', 'Kentucky', ['Louisville', 'Lexington', 'Bowling Green', 'Owensboro', 'Covington']],
    ['LA', 'Louisiana', ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles']],
    ['ME', 'Maine', ['Portland', 'Lewiston', 'Bangor', 'South Portland', 'Auburn']],
    ['MD', 'Maryland', ['Baltimore', 'Columbia', 'Germantown', 'Silver Spring', 'Waldorf']],
    ['MA', 'Massachusetts', ['Boston', 'Worcester', 'Springfield', 'Cambridge', 'Lowell']],
    ['MI', 'Michigan', ['Detroit', 'Grand Rapids', 'Warren', 'Ann Arbor', 'Lansing']],
    ['MN', 'Minnesota', ['Minneapolis', 'St. Paul', 'Rochester', 'Duluth', 'Bloomington']],
    ['MS', 'Mississippi', ['Jackson', 'Gulfport', 'Southaven', 'Hattiesburg', 'Biloxi']],
    ['MO', 'Missouri', ['Kansas City', 'St. Louis', 'Springfield', 'Columbia', 'Independence']],
    ['MT', 'Montana', ['Billings', 'Missoula', 'Great Falls', 'Bozeman', 'Helena']],
    ['NE', 'Nebraska', ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island', 'Kearney']],
    ['NV', 'Nevada', ['Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Sparks']],
    ['NH', 'New Hampshire', ['Manchester', 'Nashua', 'Concord', 'Dover', 'Rochester']],
    ['NJ', 'New Jersey', ['Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Trenton']],
    ['NM', 'New Mexico', ['Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe', 'Roswell']],
    ['NY', 'New York', ['New York City', 'Buffalo', 'Rochester', 'Albany', 'Syracuse']],
    ['NC', 'North Carolina', ['Charlotte', 'Raleigh', 'Greensboro', 'Durham', 'Winston-Salem']],
    ['ND', 'North Dakota', ['Fargo', 'Bismarck', 'Grand Forks', 'Minot', 'West Fargo']],
    ['OH', 'Ohio', ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron']],
    ['OK', 'Oklahoma', ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Edmond']],
    ['OR', 'Oregon', ['Portland', 'Salem', 'Eugene', 'Gresham', 'Hillsboro']],
    ['PA', 'Pennsylvania', ['Philadelphia', 'Pittsburgh', 'Allentown', 'Reading', 'Erie']],
    ['RI', 'Rhode Island', ['Providence', 'Warwick', 'Cranston', 'Pawtucket', 'Newport']],
    ['SC', 'South Carolina', ['Charleston', 'Columbia', 'North Charleston', 'Greenville', 'Rock Hill']],
    ['SD', 'South Dakota', ['Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings', 'Watertown']],
    ['TN', 'Tennessee', ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Clarksville']],
    ['TX', 'Texas', ['Houston', 'San Antonio', 'Dallas', 'Austin', 'Fort Worth']],
    ['UT', 'Utah', ['Salt Lake City', 'West Valley City', 'Provo', 'West Jordan', 'Orem']],
    ['VT', 'Vermont', ['Burlington', 'South Burlington', 'Rutland', 'Montpelier', 'Barre']],
    ['VA', 'Virginia', ['Virginia Beach', 'Norfolk', 'Chesapeake', 'Richmond', 'Arlington']],
    ['WA', 'Washington', ['Seattle', 'Spokane', 'Tacoma', 'Vancouver', 'Bellevue']],
    ['WV', 'West Virginia', ['Charleston', 'Huntington', 'Morgantown', 'Parkersburg', 'Wheeling']],
    ['WI', 'Wisconsin', ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine']],
    ['WY', 'Wyoming', ['Cheyenne', 'Casper', 'Laramie', 'Gillette', 'Rock Springs']],
    ['DC', 'District of Columbia', ['Washington']],
];

/** Every state as { code, name }, in list order (alphabetical, then DC). */
export const US_STATE_OPTIONS = STATE_LIST.map(([code, name]) => ({ code, name }));

// Build lookup maps
const STATE_NAME_MAP = new Map(); // lowercase name or abbrev → full state name
const STATE_TOP_CITIES = {};      // full state name → [city names]

STATE_LIST.forEach(([abbrev, name, cities]) => {
    STATE_NAME_MAP.set(name.toLowerCase(), name);
    STATE_NAME_MAP.set(abbrev.toLowerCase(), name);
    STATE_TOP_CITIES[name] = cities;
});

/**
 * Check if text matches a US state name or abbreviation.
 * Returns the full state name or null.
 */
export function matchStateName(text) {
    if (!text) return null;
    return STATE_NAME_MAP.get(text.trim().toLowerCase()) || null;
}

/** Return the postal abbreviation for a US state name or abbreviation. */
export function matchStateCode(text) {
  const name = matchStateName(text);
  return STATE_LIST.find((state) => state[1] === name)?.[0] || null;
}

/**
 * Get top cities for a state, formatted as "City, State" labels.
 */
export function getTopCitiesForState(stateName) {
    const cities = STATE_TOP_CITIES[stateName] || [];
    return cities.map(city => ({
        label: `${city}, ${stateName}`,
        display_name: `${city}, ${stateName}`,
    }));
}
